// extracted by css-extract-rspack-plugin
module.exports =  {"label":"Label__label--hq4H2"};